<template lang="pug">
  //- 一覧がないときは非表示
  //- 非表示時も高さを保つためにvisibility:hiddenを使う
  .btn-group
    a.btn.btn-primary.dropdown-toggle(href="#" :class="{disabled: hidden}" data-toggle="dropdown" aria-expanded="false", title="並び替え"): i.fa.fa-sort-amount-asc
      span.caret
    .ul.dropdown-menu.dropdown-menu-right.bcard-table-sort-selecter
      li(v-for="option in options")
        a(href="#" @click.prevent="setSort(option.sort_item)")
          i.fa.bcard-table-sort-selecter-icon(v-if="option.sort_item === current.sort_item", :class="'fa-sort-' + current.direction")
          | {{option.label}}
</template>

<script>
export default {
  name: 'Sortmenu',
  props: {
    hidden: {type: Boolean, required: false, default: false},
    options: {type: Array, required: true}, // ソート項目 [ { label: '氏名', sort_item: 'name' } ]
    current: {type: Object, required: true} // 現在のソート項目 { sort_item: '', direction: 'asc' }
  },
  methods: {
    /**
     * 並び替え処理
     * @param sort_item: 対象ソート項目
     */
    setSort: function (sort_item) {
      let direction

      // 対象ソート項目と現在のソート列を比較
      // 同じ場合
      if (sort_item === this.current.sort_item) {
        direction = this.current.direction === 'asc' ? 'desc' : 'asc'
      }
      // 異なる場合
      // 名刺交換日の場合、降順にする
      else if (sort_item === 'exchange_date') {
        direction = 'desc'
      }
      else {
        direction = 'asc'
      }

      this.$emit('change', { sort_item, direction })
    }
  }
}
</script>

<style lang="scss" scoped>
.sortmenu-hidden {
  visibility : hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AppSortmenu.vue